/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Location/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaIconLocationOn from 'DesignSystem/Svgs/TysiaIconLocationOn/index'



/** @type {import('Simple/types.js').View} */
export default function Location({
  children,
  viewPath = "/DesignSystem/CreateNewProfessionalModal/Details/Office/Search/Content/Content/Offices/Content/Office/Location"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let officePostalAddressAddressLine1ValueData = fromData.useDataValue({ viewPath,
context: 'office',
path: 'postal_address.address_line1',
})
let constantData = ', '
let officePostalAddressCityValueData = fromData.useDataValue({ viewPath,
context: 'office',
path: 'postal_address.city',
})
let constantData1 = ', '
let officePostalAddressStateValueData = fromData.useDataValue({ viewPath,
context: 'office',
path: 'postal_address.state',
})
let constantData2 = ', '
let officePostalAddressZipValueData = fromData.useDataValue({ viewPath,
context: 'office',
path: 'postal_address.zip',
})
let aggregateData = fromAggregate.join(officePostalAddressAddressLine1ValueData, constantData, officePostalAddressCityValueData, constantData1, officePostalAddressStateValueData, constantData2, officePostalAddressZipValueData)
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 cursor="default"
 type="secondary"
 marginRight={dtSpaceXxs}
 marginTop={dtSpaceXxs}
>
{childProps => (
<React.Fragment>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconLocationOn
{...childProps}
  viewPath={`${viewPath}/TysiaIconLocationOn`}
/>
)}
</TysiaButtonIcon>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 data="office.postal_address.address_line1"
 data="', '"
 data="office.postal_address.city"
 data="', '"
 data="office.postal_address.state"
 data="', '"
 data="office.postal_address.zip"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}